import script from "./recipients-rule-accordion.vue?vue&type=script&setup=true&lang=js"
export * from "./recipients-rule-accordion.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__